/* globals PROJECT_3_MIXPANEL_TOKEN */

// TODO move these functions to common/report/report-tracker or tracking-setup?

import pick from 'lodash/pick';

import {initMixpanel} from '../report/tracking-setup';
import {MPContext} from '../mp-context';

const mpContext = new MPContext();
export const mixpanel = initMixpanel(PROJECT_3_MIXPANEL_TOKEN);

function getUserData() {
  return pick(mpContext, [`projectId`, `userEmail`, `userId`, `userName`]);
}

export function setupTracking(instanceName, token) {
  initMixpanel(token, instanceName);
}

export function trackEvent({productionEventPrefix = ``, instanceName, isProductionEvent, properties, trackingEvent}) {
  const user = getUserData();
  properties = {
    ...properties,
    Email: user.userEmail,
    project_id: user.projectId,
  };

  mixpanel[instanceName].track(trackingEvent, {
    ...properties,
    'User ID': user.userId,
  });

  if (isProductionEvent) {
    const eventName = productionEventPrefix ? `[${productionEventPrefix}] ${trackingEvent}` : trackingEvent;
    mixpanel.track(eventName, properties);
  }
}

export function identifyUser(instanceName) {
  const user = getUserData();
  mixpanel[instanceName].identify(user.userId);
  mixpanel[instanceName].people.set({
    $email: user.userEmail,
    $name: user.userName,
  });

  return user;
}
